import { render } from "./appmain.vue?vue&type=template&id=3843d628"
import script from "./appmain.vue?vue&type=script&lang=js"
export * from "./appmain.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__